import { gql, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import CustomFormGenerator from "./Generator";

const FETCH_SHIPMENT_FOR_CUSTOM_FORM = gql`
  query FETCH_SHIPMENT_FOR_CUSTOM_FORM($id: ID!) {
    shipment(id: $id) {
      id
      invoiceNumber
      consigneeName
      addr
      shipmentInvoices {
        id
        invoice {
          number
        }
        shipmentInvoiceRows {
          id
          hsCode
          product {
            id
            number
            name
            images: computedImages(size: "300x300") {
              id
              url
            }
          }
          packingName
          qty
          customsName
          customsBrand
          customsUsage
          customsValue
          customsSize
          customsMaterials
          totalCarton
          totalNetWeight
          totalGrossWeight
          totalCbm
        }
      }
    }
  }
`;

const CustomFormView = () => {
  const { id: shipmentId } = useParams();
  const { loading, error, data } = useQuery(FETCH_SHIPMENT_FOR_CUSTOM_FORM, {
    variables: { id: shipmentId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={parseError(error)} />;

  return <CustomFormGenerator shipment={data.shipment} />;
};

export default CustomFormView;
